import { initContract } from '@ts-rest/core';
import { createApi } from './ts-rest';

const c = initContract();
export const contract = c.router({
  /**
   * Track API
   */
  trackIdentify: {
    method: 'POST',
    path: '/track/identify',
    responses: {
      200: c.type<void>(),
    },
    body: c.type<{
      properties: Record<string, any>;
    }>(),
    summary: 'Identify a user',
  },
  trackPage: {
    method: 'POST',
    path: '/track/page',
    responses: {
      200: c.type<void>(),
    },
    body: c.type<{
      properties: Record<string, any>;
    }>(),
    summary: 'Track a page view',
  },
});

const { api, query } = createApi(contract, {
  baseUrl: '/hydra',
});

export type Contract = typeof contract;

export { api, query };
